import { IRecommendOrderErrorType } from './interfaces/recommendOrderError';

/**
 * 推奨発注画面のビューモデル
 */
export class RecommendOrderViewModel {
  /**
   * 表示に使用するエラーメッセージを取得する
   * @param type - エラータイプ
   */
  public getI18nKeyPathOfErrorMessage = (type: IRecommendOrderErrorType): string => {
    switch (type) {
      case 'API_ERROR':
        return 'API取得エラーメッセージ';
      case 'INVALID_INVENTORY':
        return '無効な在庫エラーメッセージ';
    }
  };
}
